import { setLocalStorageLoginToken } from "src/utils/localStorageWorker";
import { FlowioThunkCreator } from "../../types";

import * as R from "../../../requests/impersonation/requestCreators";
import * as AC from "../actionCreators";
import * as S from "../selectors";

type ThunkCreator = FlowioThunkCreator<void>;

export const stopImpersonating: ThunkCreator = () => (dispatch, getState) =>
  Promise.resolve().then(async () => {
    const isSubmitting = S.getIsImpersonationSubmitting(getState());
    if (isSubmitting) return;

    dispatch(AC.stopImpersonationRequest());

    try {
      const response = await R.cancelImpersonization();

      // todo: Authorization
      setLocalStorageLoginToken(response.data);

      dispatch(AC.stopImpersonationSuccess());
    } catch (e) {
      dispatch(AC.stopImpersonationError());
    }
  });

export type StopImpersonating = ThunkCreator;
